import { render, staticRenderFns } from "./partes-do-turno.vue?vue&type=template&id=1c6a4cfc&scoped=true&"
import script from "./partes-do-turno.vue?vue&type=script&lang=js&"
export * from "./partes-do-turno.vue?vue&type=script&lang=js&"
import style0 from "./partes-do-turno.vue?vue&type=style&index=0&id=1c6a4cfc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a4cfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c6a4cfc')) {
      api.createRecord('1c6a4cfc', component.options)
    } else {
      api.reload('1c6a4cfc', component.options)
    }
    module.hot.accept("./partes-do-turno.vue?vue&type=template&id=1c6a4cfc&scoped=true&", function () {
      api.rerender('1c6a4cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/ui-registry/partes-do-turno/partes-do-turno.vue"
export default component.exports